module.exports = __webpack_public_path__ + "static/img/7.4ed69d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/7.png
// module id = Yw1a
// module chunks = 0